// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"70":"ccd60962","77":"04969f32","315":"ce9c1d3b","357":"adfd3f2c","394":"9c5dd8cd","397":"f6781e59","684":"fc3b0158","767":"61162c39","780":"c501fc6a","868":"e02898e1","895":"e73c2d9d","913":"ace8224a","915":"42e17acf","919":"1880fa69"}[chunkId] + ".chunk.js";
};